class BundleBuyXGetY extends HTMLElement {
  constructor() {
    super();
    this.operations = {
      add: 'add',
      remove: 'remove',
    };

    this.quantity = {
      minusButton: this.querySelector('.bxgy__quantity-minus'),
      plusButton: this.querySelector('.bxgy__quantity-plus'),
    };

    this.packQuantity = parseInt(this.dataset.quantity);
    this.packQuantityOffered = parseInt(this.dataset.quantityOffered);

    const selectedOptionElement = this.querySelector('option:checked');
    this.selectedOption = selectedOptionElement ? selectedOptionElement.value : null;

    const inputValueElement = this.querySelector('.bxgy__quantity-input');
    this.inputValue = inputValueElement ? inputValueElement.value : null;
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    this.addEventListener('click', this.selectCustomElement.bind(this));
    this.addEventListener('change', this.selectCustomElement.bind(this));

    this.quantity.minusButton.addEventListener('click', this.updateQuantity.bind(this, this.operations.remove));
    this.quantity.plusButton.addEventListener('click', this.updateQuantity.bind(this, this.operations.add));

    document.addEventListener('deployer:update-prices', (event) => {
      this.updatePrice(event);
    });
  }

  updatePrice(event) {}

  updateFakeComparePrice(variant) {
    const fakeComparePrice = this.querySelector('.bxgy__product-compare-at-price-fake');

    if (isNaN(this.packQuantityOffered)) {
      fakeComparePrice.classList.add('hide');
      return;
    }

    if (!fakeComparePrice) {
      fakeComparePrice.classList.add('hide');
      return;
    }

    if (this.packQuantityOffered <= 0) {
      fakeComparePrice.classList.add('hide');
      return;
    }

    ProductPageUIUpdater.updatePricesInBuyXgetY(
      variant.price * this.packQuantity - variant.price * this.packQuantityOffered,
      variant.price * this.packQuantity,
      this.querySelector('.bxgy__product-compare-at-price-fake'),
      this.querySelector('.bxgy__product-price'),
    );

    const productPriceWrap = document.querySelector('.product__price__wrap');
    const productPrice = productPriceWrap.querySelector('span[data-product-price]');
    const productComparePrice = productPriceWrap.querySelector('[data-compare-price]');

    if (productPriceWrap) {
      ProductPageUIUpdater.updatePricesTopProductPage(
        productPrice,
        productComparePrice,
        variant.price * this.packQuantity - variant.price * this.packQuantityOffered,
        variant.price * this.packQuantity,
      );
    }
  }

  selectCustomElement() {
    const elements = document.querySelectorAll('buy-x-get-y');
    elements.forEach((element) => {
      element.classList.remove('selected');
    });
    this.classList.add('selected');

    this.updateQuantity('');
    this.updateProductPageSelectedId();
    this.dispatchEvent(new CustomEvent('bxgy:selectedElement', { bubbles: true, cancelable: true }));
  }

  updateQuantity(operation = '') {
    if (this.classList.contains('selected')) {
      const quantityInputElement = this.querySelector('.bxgy__quantity-input');
      let inputValue = parseInt(quantityInputElement.value);

      if (operation === this.operations.add) {
        inputValue++;
      }

      if (operation === this.operations.remove) {
        inputValue <= 1 ? (inputValue = 1) : inputValue--;
      }

      if (quantityInputElement) quantityInputElement.value = inputValue.toString();
      this.updateProductQuantity(inputValue);
    }
  }

  updateProductQuantity(inputValue = 0) {
    let themeQuantityInput = document.querySelector('.quantity__input');

    if (!isNaN(this.packQuantity)) {
      themeQuantityInput.value = (inputValue * this.packQuantity).toString();
    } else {
      themeQuantityInput.value = inputValue.toString();
    }
  }

  updateProductPageSelectedId() {
    //executing this function seems
    this.resetMatchingOption();
  }

  resetMatchingOption() {
    const selectElements = this.querySelectorAll('.bxgy__product-options select');
    const globalThis = this;
    selectElements.forEach(function (select) {
      const dataOption = select.dataset.optionName;
      const optionValue = select.value;
      globalThis.selectMatchingOption(dataOption, optionValue);
    });
  }

  selectMatchingOption(dataOption, optionValue) {
    const dataOptionName = dataOption.toLowerCase();
    const selectorWrapper = document.querySelectorAll('.product__selectors .selector-wrapper');

    selectorWrapper.forEach((selector) => {
      const selectorOptionName = selector.querySelector('.radio__legend__label');

      if (selectorOptionName.innerText.toLowerCase() === dataOptionName) {
        const radioButtons = selector.querySelectorAll('.radio__button input');
        const swatchButtons = selector.querySelectorAll('.swatch__button input');

        radioButtons.forEach((radioButton) => {
          if (radioButton.value === optionValue) {
            radioButton.click();
          }
        });

        swatchButtons.forEach((swatchButton) => {
          if (swatchButton.value === optionValue) {
            swatchButton.click();
          }
        });
      }
    });
  }
}
if (!customElements.get('buy-x-get-y')) customElements.define('buy-x-get-y', BundleBuyXGetY);

function selectMatchingOption(dataOption, optionValue) {
  const dataOptionName = dataOption.toLowerCase();
  const selectorWrapper = document.querySelectorAll('.product__selectors .selector-wrapper');

  selectorWrapper.forEach((selector) => {
    const selectorOptionName = selector.querySelector('.radio__legend__label');

    if (selectorOptionName.innerText.toLowerCase() === dataOptionName) {
      const radioButtons = selector.querySelectorAll('.radio__button input');
      const swatchButtons = selector.querySelectorAll('.swatch__button input');

      radioButtons.forEach((radioButton) => {
        if (radioButton.value === optionValue) {
          radioButton.click();
        }
      });

      swatchButtons.forEach((swatchButton) => {
        if (swatchButton.value === optionValue) {
          swatchButton.click();
        }
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('buy-x-get-y').forEach(function (element) {
    element.click();
  });
  document.querySelectorAll('buy-x-get-y').forEach(function (element) {
    if (element.dataset.selectedBundle === 'true') {
      element.click();
    }
  });
});
